import React from 'react';
import HomeCard from "./HomeCard";
import {BarChart2} from "lucide-react";

const HomeStatCard = ({ title, value, icon: Icon, trend }) => {
    return (
        <HomeCard className="flex items-center justify-between">
            <div className="flex items-center">
                <div className="p-3 bg-indigo-100 rounded-full mr-4">
                    <Icon className="h-6 w-6 text-indigo-600" />
                </div>
                <div>
                    <h4 className="text-sm font-medium text-gray-500">{title}</h4>
                    <p className="text-2xl font-bold text-gray-800">{value}</p>
                </div>
            </div>
            {trend && (
                <div className={`flex items-center ${trend > 0 ? 'text-green-500' : 'text-red-500'}`}>
                    {/*<BarChart2 className={`h-4 w-4 mr-1 ${trend < 0 ? 'transform rotate-180' : ''}`} />*/}
                    {/*<span className="text-sm font-medium">{Math.abs(trend)}%</span>*/}
                </div>
            )}
        </HomeCard>

    );
};

export default HomeStatCard;
